import React from 'react'
import { BirthButton, Content } from './styles'
import { IconComponent } from '~/assets/icons/component'
import { TimelineTooltipEnclosed } from '~/components/shared'
import { IAdmissionRowSlots, ITimelineMaternalInfant } from '~/interfaces'
import { createAdmissionsStructure, transformDate } from '~/utils'

interface BirthEventProps {
  birthAdmission: ITimelineMaternalInfant.IBirthAdmission
  handleClick: (birthData: ITimelineMaternalInfant.IBirthAdmission) => void
  birthType: string
}

export const BirthEvent = ({ birthAdmission, handleClick, birthType }: BirthEventProps): JSX.Element => {
  const [positionedBirth] = createAdmissionsStructure({
    admissions: [birthAdmission] as IAdmissionRowSlots[],
    mode: 'weekly'
  })

  const birthTypeInformation = birthType ? `Internação de parto (${birthType.toLowerCase()})` : `Internação de parto`
  const description = `${birthTypeInformation} - ${transformDate({
    date: new Date(birthAdmission.birthDate),
    dateFormat: 'dd/MM/yyyy'
  })}`

  return (
    <BirthButton
      width={positionedBirth.width}
      position={positionedBirth.percentagePosition}
      onClick={() => handleClick(birthAdmission)}
    >
      <TimelineTooltipEnclosed description={description}>
        <Content>
          <div className="background" data-testid="birth-background" />
          <IconComponent name={'baby'} />
        </Content>
      </TimelineTooltipEnclosed>
    </BirthButton>
  )
}
